exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-notification[data-v-144c176e]{font-size:13px}.access-icon[data-v-144c176e]{color:#4fc08d96!important}.col-icon[data-v-144c176e],.error-icon[data-v-144c176e]{font-size:25px!important;padding:13px}.error-icon[data-v-144c176e]{color:#fbb5b8!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-144c176e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/components/layouts/tables/Notification.vue
// module id = 311
// module chunks = 0